import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import {
  ApiDataResponse,
  AuthorizationGuard,
  AuthorizationPermission,
} from "../types";

interface IGetDataProps {
  guardName: AuthorizationGuard;
}

interface GetPermissionsRequest extends IGetDataProps {
  token: string;
}

export const QUERY_KEY_FOR_PERMISSIONS = "authorization-permissions";
const AUTHORIZATION_URL = `${END_POINT.BASE_URL}/v1/administrator/authorization`;

const getPermissions = async ({
  token,
  guardName,
}: GetPermissionsRequest): Promise<ApiDataResponse<AuthorizationPermission[]>> => {
  const response = await axios.get<ApiDataResponse<AuthorizationPermission[]>>(
    `${AUTHORIZATION_URL}/permissions`,
    {
      params: { guard_name: guardName },
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const useGetPermissions = ({ guardName }: IGetDataProps) => {
  const { token } = useGetUserInfo();
  return useQuery<ApiDataResponse<AuthorizationPermission[]>, Error>(
    [QUERY_KEY_FOR_PERMISSIONS, guardName],
    () => getPermissions({ guardName, token }),
    {
      enabled: Boolean(token),
    }
  );
};